/**
 * Builds the headers for an outgoing API request. The selected studio goes in `X-Studio-Id`,
 * but only when there actually is one: an absent studio must leave the header out, never send
 * the literal string "undefined" — the backend binds `X-Studio-Id` to `int?` and rejects
 * "undefined" with a 400, which broke every studio-scoped call made before a studio was picked
 * (e.g. a global admin opening a studio right after login).
 */
export const buildRequestHeaders = (
  existingHeaders: Record<string, unknown> | undefined,
  selectedStudioId: string | number | undefined | null,
): Record<string, unknown> => {
  const headers: Record<string, unknown> = {
    ...existingHeaders,
    "Content-Type": "application/json",
  };

  if (selectedStudioId !== undefined && selectedStudioId !== null && selectedStudioId !== "") {
    headers["X-Studio-Id"] = selectedStudioId;
  }

  return headers;
};
